import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Route, Switch} from 'react-router'

/**
 * Given a list of paths, where the first one is the exact root. Shows a link as selected when any subpath in the
 * route tree is active.
 *
 * Similar to RouteLink, except handles a whole tree where the root of the tree can be the base app path (i.e. "/").
 *
 * This is necessary because "/" requires exact match, but other sub paths do not, and we only want to render
 * exactly one link.
 */
class RouteTreeLink extends Component {
	render() {
		const {firstExact = true, className, to, matches, catchAll = true, children, disabled} = this.props;
		
		const render = ({match}) => {
			return disabled ? (
				<span className={`${className || ''} ${match ? 'selected' : ''}`}>{children}</span>
			) : (
				<Link to={to} className={`${className || ''} ${match ? 'selected' : ''}`}>{children}</Link>
			);
		};
		
		return (
			<Switch>
				{matches && matches.map((match, idx) => (
					<Route
						path={match}
						exact={idx === 0 && firstExact}
						render={render}
					/>
				))}
				{catchAll ? (<Route
					path="*"
					render={() => (render(false))}
				/>) : undefined}
			</Switch>
		);
	}
}

export default RouteTreeLink;


// WEBPACK FOOTER //
// ./src/widgets/RouteTreeLink.js